<template>
    <section>
		<b-field>
			<b-autocomplete ref="bauto"
							v-model="inputVal"
							icon="search"
							icon-pack="fa"
							:data="datasource"
							:placeholder="placeholder"
							:field="datafield"
							@typing="ontyping"
							:keep-first="keepFirst"
							expanded
							@select="option => selectWrapper(option)"
							@keydown.native.enter="onenter">
				<template v-if="shownoresultstext" slot="empty">
					{{noresultstext}}
				</template>
			</b-autocomplete>

			<p class="control">
				<b-select class="is-hidden-tablet " v-model="searchoptionspicked" @input="updateAutocomplete" expanded>
					<option v-for="d in SearchOptions" :value="d.value">{{d.name}}</option>
				</b-select>
			</p>
			<p class="control">
				<b-select class="is-hidden-mobile" v-model="searchoptionspicked" @input="updateAutocomplete" expanded>
					<option v-for="d in SearchOptions" :value="d.value">{{d.name}}</option>
				</b-select>
			</p>
			<p class="control">
				<button class="button is-info is-hidden-mobile " v-on:click="submit">{{searchtext}}</button>
			</p>
			<p class="control">
				<button class="button is-hidden-mobile " v-on:click="clear">{{cleartext}}</button>
			</p>
		</b-field>
    </section>
</template>
<script type="text/javascript">
export default {
		name: "rxeob-drug-search-autocomplete",
		props: {
			value: {
				type: [String,Number],
				default: null
			},
            searchoptionspicked: {
					type: [Number],
					default: null
				},
			ontyping: {
				type: Function,
				default: function(){
				}
			},
			datasource: {
				type: [Array],
				default: function() {
					return [];
				}
			},
			placeholder: {
				type: String,
				default: "Search"
            },
            searchtext: {
                type: String,
                default: "Search"
            },
            cleartext: {
                type: String,
                default: "Clear"
            },
            noresultstext: {
                type: String,
                default: "No results found"
            },
            shownoresultstext: {
                type: Boolean,
                default: true
            },
			datafield: {
				type: String,
				default: 'value'
			},
			onselect: {
				type: Function,
				default: function() {
					console.log("implement onselect for component");
				}
			},
			keepfirst: {
				type: Boolean,
				default: false
			},
			onsubmit: {
				type: Function,
				default: function() {
                    this.$refs.bauto.enterPressed();
				}
            },
            onenter: {
                type: Function,
                default: function () {
                    console.log("Implement on enter for component");
                }
            },
            clearcallback: {
                type: Function,
                default: function(){
                }
			},
		},
        data() {
			return {
                SearchOptions: [{ name: "Label Name", value: 1 }, { name: "NDC", value: 2 }, { name: "GPI-14", value: 3 }],
				inputVal: this.value,
				data: [],
                ndcSearchSelected: true,
                gpiSearchSelected: true,
                lnSearchSelected: true,
                selected: null,
                isFetching: false,
				keepFirst: this.keepfirst
            }
        },
		watch: {
			inputVal(val) {
			  this.$emit('input', val);
			}
		},
        methods: {
			selectWrapper: function (option) {
				this.onselect(option);
			},
			clear: function(){
				this.inputVal = "";
                this.clearcallback();
			},
			submit: function(){
				this.onsubmit();
			},
			updateAutocomplete: function (event) {
				this.$emit('clicked', this.searchoptionspicked)
                this.inputVal = "";
                this.clearcallback();
			}
        }
}
</script>



// WEBPACK FOOTER //
// RxeobDrugSearchAutocomplete.vue?e841c828